import React from 'react';
import PropTypes from 'prop-types';
import { Circle } from 'rc-progress';

const Progress = ({ percent, strokeWidth, strokeColor, message }) => (
  <div className="uploadingProgress">
    <div className="innerUploadingProcessComponent">
      <Circle
        percent={percent}
        strokeWidth={strokeWidth}
        strokeColor={strokeColor}
      />
      <span className="uploadingPercentage">
        {percent || 0}
        %
      </span>
    </div>
    {
      message
        ? (
          <div className="progressUnderMessage">
            { message }
          </div>
        )
        : null
    }
  </div>
);

Progress.propTypes = {
  percent: PropTypes.number,
  strokeWidth: PropTypes.string,
  strokeColor: PropTypes.string,
  message: PropTypes.string,
};

Progress.defaultProps = {
  strokeWidth: '4',
  strokeColor: '#3989E3',
  percent: 0,
  message: '',
};

export default Progress;
